<script>
  import EmployeeCard from "./../components/EmployeeCard.svelte";
  import Container from "../shared/Container.svelte";
  import Select from "svelte-select";
  import Layout from "../Layout/Layout.svelte";
  import Modal from "../shared/Modal.svelte";
  import config from "../stores/config";
  import axios from "axios";
  import * as ls from "local-storage";
  import { Circle2 } from "svelte-loading-spinners";
  import { onMount } from "svelte";
  import Loading from "../shared/Loading.svelte";
  import Empty from "../shared/Empty.svelte";

  // Adding A New Employee -------------------------------------------------------------------
  let newEmployee = {
    name: "",
    amount: "",
    currency: null,
    role: "",
    tel: null,
  };

  const numberWithCommas = (x) => {
    return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  let showAddEmployeeForm = false;
  let addEmployeeLoading = false;

  const handleAddNewEmployee = async (e) => {
    for (const field in newEmployee) {
      if (!newEmployee[field]) {
        alert(`Veuillez remplir tous les champs!`);
        return;
      }
    }

    addEmployeeLoading = true;

    let data = {
      ...newEmployee,
      currency: newEmployee.currency.value,
    };

    axios
      .post(`${$config.backendURL}/employees`, data, {
        headers: { authorization: ls.get("jwt") },
      })
      .then((res) => {
        showAddEmployeeForm = false;
        addEmployeeLoading = false;

        newEmployee = {
          name: "",
          amount: "",
          currency: null,
          role: "",
          tel: "",
        };

        fetchEmployees();
      })
      .catch((err) => {
        addEmployeeLoading = false;
        console.log(err);
        alert(err);
      });
  };

  // Query For Employees ------------------------------------------------------------------------------

  let employees = null;
  let queryURL = "";

  /* Query Parameters */
  let page = 1;
  let searchkey = "";

  const fetchEmployees = () => {
    employees = null;

    queryURL = `${$config.backendURL}/employees/page/${page}?`;
    queryURL += `&searchkey=${searchkey || ""}`;

    axios
      .get(queryURL, { headers: { authorization: ls.get("jwt") } })
      .then((res) => {
        employees = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlePrevPage = () => {
    if (page <= 1) page = 1;
    else {
      page = page - 1;
      fetchEmployees();
    }
  };
  const handleNextPage = () => {
    if (page <= 0) page = 0;
    page = page + 1;
    fetchEmployees();
  };

  const handleRefresh = () => {
    page = 1;
    searchkey = null;
    fetchEmployees();
  };

  onMount(() => {
    fetchEmployees();
  });
</script>

<svelte:head>
  <title>SAMAKI EXPRESS | Tous les employés</title>
</svelte:head>

<Layout>
  <Modal
    show={showAddEmployeeForm}
    on:modalClose={() => {
      showAddEmployeeForm = false;
    }}
  >
    <div class="grid gap-y-2">
      <input
        bind:value={newEmployee.name}
        type="text"
        placeholder="Nom Complet"
        required
      />

      <input
        bind:value={newEmployee.amount}
        type="number"
        placeholder="Montant"
      />

      <Select
        items={["DOLLARS", "FRANCS"]}
        bind:selectedValue={newEmployee.currency}
        placeholder="Devise"
      />

      <input
        bind:value={newEmployee.role}
        type="text"
        placeholder="Fonction"
        required
      />

      <input bind:value={newEmployee.tel} type="text" placeholder="Telephone" />

      {#if addEmployeeLoading}
        <div class="grid grid-cols-1 gap-8">
          <div class="btn btn-primary">
            <Circle2
              size="25"
              unit="px"
              colorOuter="#F4A261"
              colorCenter="#40B3FF"
              colorInner="#676778"
            />
            <span class="ml-4">Veuillez Patienter...</span>
          </div>
        </div>
      {:else}
        <!-- else content here -->
        <div class="flex">
          <button
            style="width: 100%;"
            class="btn btn-primary"
            on:click={handleAddNewEmployee}
          >
            <ion-icon name="checkmark-circle" class="text-2xl mr-3" />
            Sauver
          </button>
          <button
            style="width: 100%;"
            class="ml-4 btn btn-secondary"
            on:click={(e) => (showAddEmployeeForm = false)}
          >
            <ion-icon name="close-circle" class="text-2xl mr-3" />
            Fermer
          </button>
        </div>
      {/if}
    </div>
  </Modal>

  <div class="py-8" />

  <Container>
    <div class="mt-2 grid grid-cols-1 md:grid-cols-3 gap-2">
      <!--  -->
      <button
        class="btn btn-blue"
        on:click={(e) => {
          showAddEmployeeForm = true;
        }}
        style="width: 100%;"
      >
        <ion-icon name="add-circle" class="text-2xl mr-3" />
        Ajouter un Employé
      </button>
      <!--  -->
      <button
        class="btn btn-secondary"
        on:click={handleRefresh}
        style="width: 100%;"
      >
        Actualiser
        <ion-icon name="refresh-circle" class="text-2xl ml-3" />
      </button>
      <!--  -->
      <div class="flex justify-center">
        <input
          bind:value={searchkey}
          on:input={fetchEmployees}
          class="shadow-sm"
          type="text"
          placeholder="Rechercher ici..."
        />
        <button class="ml-2 btn btn-blue" on:click={fetchEmployees}>
          <ion-icon name="search-circle" class="text-2xl" />
        </button>
      </div>
    </div>
  </Container>

  <Container>
    {#if employees == null}
      <Loading text="Chargement..." />
    {:else}
      <div class="my-4 grid grid-cols-1 lg:grid-cols-2 gap-2">
        {#each employees as employee (employee._id)}
          <div class="">
            <EmployeeCard
              {...employee}
              on:delete={() => {
                page = 1;
                searchkey = "";
                fetchEmployees();
              }}
              on:update={() => {
                page = 1;
                searchkey = "";
                fetchEmployees();
              }}
            />
          </div>
        {:else}
          <div class="col-span-full">
            <Empty />
          </div>
        {/each}
      </div>

      <div class="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-2">
        <button
          class="btn btn-secondary"
          style="width: 100%;"
          on:click={() => {
            handlePrevPage();
          }}
        >
          <ion-icon name="arrow-back-circle" class="text-2xl mr-2" />
          Page Prec.
        </button>
        <button
          class="btn btn-secondary"
          style="width: 100%;"
          on:click={() => {
            handleNextPage();
          }}
        >
          Page Suiv.
          <ion-icon name="arrow-forward-circle" class="text-2xl ml-2" />
        </button>
      </div>
    {/if}
  </Container>
</Layout>

<style>
  .stat-card {
    background-image: url("data:image/svg+xml,%3Csvg width='84' height='48' viewBox='0 0 84 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h12v6H0V0zm28 8h12v6H28V8zm14-8h12v6H42V0zm14 0h12v6H56V0zm0 8h12v6H56V8zM42 8h12v6H42V8zm0 16h12v6H42v-6zm14-8h12v6H56v-6zm14 0h12v6H70v-6zm0-16h12v6H70V0zM28 32h12v6H28v-6zM14 16h12v6H14v-6zM0 24h12v6H0v-6zm0 8h12v6H0v-6zm14 0h12v6H14v-6zm14 8h12v6H28v-6zm-14 0h12v6H14v-6zm28 0h12v6H42v-6zm14-8h12v6H56v-6zm0-8h12v6H56v-6zm14 8h12v6H70v-6zm0 8h12v6H70v-6zM14 24h12v6H14v-6zm14-8h12v6H28v-6zM14 8h12v6H14V8zM0 8h12v6H0V8z' fill='%23000000' fill-opacity='0.02' fill-rule='evenodd'/%3E%3C/svg%3E");
  }
</style>
